import { Component, OnInit, Inject, ViewEncapsulation, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { DOCUMENT, DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute , Router } from '@angular/router';
import { Response, Http } from '@angular/http';

import { symptomCheckerFormConst } from './suggest-diagnosis-form-constant';
import { SuggestDiagnosisService } from './../services/suggest-diagnosis.service';
import { SymptomDetailsService } from './../services/symptom-details-service';
import * as Swiper from 'swiper/js/swiper';
import { environment } from '../../environments/environment';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/from';
import 'rxjs/operator/map';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/merge';

@Component({
  selector: 'app-suggest-diagnosis',
  templateUrl: './suggest-diagnosis.component.html',
  styleUrls: ['./suggest-diagnosis.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class SuggestDiagnosisComponent implements OnInit {
  /* Common */
  FormSwiper: any;
  activeIndex: Number;
  currentState: Array<String>;
  renderer2: Renderer2;
  /*--Basic Info--*/
  suggestForm: FormGroup;
  ageGroupControls: AbstractControl;
  genderCheckControls: AbstractControl;
  regionGroupControls: AbstractControl;
  pregnantControls: AbstractControl;

  ageGroup: String;
  ageGroupDisplay: Array<String>;
  ageGroupOptions: Array<Object>;
  genderCheck: String;
  genderDisplay: Object;
  regionGroup: String;
  regionGroupOptions: Array<Object>;
  pregnant: String;
  pregnantDisplay: Array<String>;
  /*--Symptoms--*/
  symptoms: Array<String>;
  prevSymptoms: Array<String>;
  public selected: string;
  public symptomSuggestions: any;
  showSymptomSearch: boolean;

  editBasicDetails: boolean;
  editBasicHeading: boolean;
  commonSymptoms: Array<String>;
  search: any;
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  formatter: any;
  /*--Possible Diagnosis--*/
  loadingResults: boolean;
  loadingStyle: any;
  loadingSpinnerStyle: any;
  public diagnosisResults: any;
  public diagnosisNoResults: boolean;
  // public triage_tool_QueryParams: Object;
  public pendingRequests: number;
  showPageLevelError: Boolean = false;
  @ViewChild('symptomCheckerId', {read: ElementRef}) symptomCheckerId: ElementRef;
  @ViewChild('diagnosisResultsId', {read: ElementRef}) diagnosisResultsId: ElementRef;
  @ViewChild('symtomEnterMobile', {read: ElementRef}) symtomEnterMobile: ElementRef;
  @ViewChild('symptomDetailsId', {read: ElementRef}) symptomDetailsId: ElementRef;
  @ViewChild('articleDetailsId', {read: ElementRef}) articleDetailsId: ElementRef;


  /*--Diagnosis Details & Article Details--*/
  symptomDetails: any;
  articleDetails: any;
  symptomDetailsShow: Boolean;

  constructor(
    private fb: FormBuilder,
    private SuggestDiagnosisService: SuggestDiagnosisService,
    private ActRoute: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private http: Http,
    private SymptomDetailsService: SymptomDetailsService,
    private sanitizer: DomSanitizer,
    renderer: Renderer2
  ) {
    this.renderer2 = renderer;
    this.currentState = ['BASIC INFO', 'PATIENTS SYMPTOMS', 'POSSIBLE DIAGNOSIS', 'DIAGNOSIS DETAILS', 'ARTICLE DETAILS'];
    this.commonSymptoms = ['fever', 'headache', 'nausea', 'sore throat', 'fatigue', 'dizziness', 'abdominal pain'];
    this.symptoms = [];
    this.prevSymptoms = [];
    this.showSymptomSearch = false;
    this.loadingResults = false;
    this.pendingRequests = 0;
    this.loadingStyle = {
        'background-color': 'rgba(255, 255, 255, 0.5)',
        display: 'none',
        height: '500px',
        width: '980px',
        position: 'absolute',
        'z-index': 2000,
        'text-align': 'center',
    };
    this.loadingSpinnerStyle = {
        'text-align': 'center',
        display: 'inline-block',
        padding: '80px 10px 10px 10px',
        'margin-top': '30px'
    };
    this.symptomDetailsShow = false;
    if (ActRoute.snapshot.params.age) {
      this.activeIndex = 2;
    }

    this.symptomSuggestions = (text$: Observable<string>) =>
    text$
    .debounceTime(300)
    .distinctUntilChanged()
    .do(() => this.searching = true)
    .switchMap(term =>
      this.getSymptomsAsObservable(term)
        .do(() => this.searchFailed = false)
        .catch(() => {
          this.searchFailed = true;
          return Observable.of([]);
        }))
    .do(() => this.searching = false)
    .merge(this.hideSearchingWhenUnsubscribed);

    this.formatter = (x: {term: string}) => '';

    if (ActRoute.snapshot.params.age && ActRoute.snapshot.params.gender && ActRoute.snapshot.params.region && ActRoute.snapshot.params.symptoms) {
      this.ageGroup = ActRoute.snapshot.params.age;
      this.genderCheck = ActRoute.snapshot.params.gender;
      this.regionGroup = ActRoute.snapshot.params.region;

      this.loadingResults = true;
      this.ActRoute.params
      .map(params => params)
      .subscribe((data) => {
        // console.log(this.FormSwiper);
        if (data.age && data.gender && data.region && data.symptoms && data.pregnant) {
          this.ageGroup = data.age;
          this.genderCheck = data.gender;
          this.regionGroup = data.region;
          this.pregnant = data.pregnant;
          this.symptoms = data.symptoms.split(',');
          if (this.pendingRequests > 0) {
            if (this.FormSwiper.activeIndex !== 2) {
              this.showLoadingAndDisplaySearch();
              this.FormSwiper.slideNext(1000, true);
            }
          }
          this.prevSymptoms = data.symptoms.split(',');
          this.SuggestDiagnosisService.SuggestDifferentialDiagnosis(data.age , data.gender, data.region, data.pregnant, data.symptoms, this.pendingRequests).subscribe(res => {
            this.symptomDetails = undefined;
            this.articleDetails = undefined;
            this.loadingStyle.display = 'none';
            this.pendingRequests++;
            this.editBasicHeading = true;
            this.editBasicDetails = true;
            this.loadingResults = false;
            this.diagnosisResults = res.diagnosis_checklist;
			      this.diagnosisNoResults = ((typeof this.diagnosisResults.NoResult) == "object");
            // this.triage_tool_QueryParams = this.parseWhereNowUrl(res.diagnosis_checklist.triage_api_url.slice(43));
            this.activeIndex = 2;
            this.resetSlideHeight(100);
            this.symptomCheckerId.nativeElement.scrollIntoView();

            // this.router.events.subscribe((evt) => {
            //     console.log('naviagtionEnd');
            //     if (!(evt instanceof NavigationEnd)) {
            //         return;
            //     }
            //     window.scrollTo(this.diagnosisResultsId.nativeElement.offsetTop);
            // });
          });
        }
      });
    }else {
        this.ageGroup = '';
        this.genderCheck = '';
        this.regionGroup = '12';
        this.pregnant = '0';
        this.loadingResults = false;
        this.editBasicDetails = false;
    }
  }



  ngOnInit() {
    console.log('Environment' + environment.envName);
    // console.log('ngOnit');
    if (this.activeIndex !== undefined && this.activeIndex === 2) {
      this.buildSwiper(2);
      if (this.FormSwiper.length === 2) {
        this.FormSwiper = this.FormSwiper[0];
      }
      this.FormSwiper.on('orientationchange', function(){
        setTimeout(() => {
          this.updateSize();
        }, 100);
      });
    }else {
      this.buildSwiper(0);
      if (this.FormSwiper.length === 2) {
        this.FormSwiper = this.FormSwiper[0];
      }
      this.FormSwiper.on('orientationchange', function(){
        setTimeout(() => {
          this.updateSize();
        }, 100);
      });
    }
    this.ageGroupOptions = symptomCheckerFormConst.ageGroups;
    this.ageGroupDisplay = symptomCheckerFormConst.getAgeGroups;
    this.genderDisplay = {'f': 'Female', 'm': 'Male'};
    this.regionGroupOptions = symptomCheckerFormConst.regionGroups;
    this.pregnantDisplay = ['not pregnant', 'pregnant'];
    this.buildForm();
  }

  /*--------------------------------------------- Common Operations Start ------------------------------------*/
  // public onWhereNow(): void {
  //   // console.log(this.suggestForm.value);
  //   // console.log(this.triage_tool_QueryParams);
  //   if (this.triage_tool_QueryParams !== undefined) {
  //     this.router.navigate(['/where-to-go-tool'], { queryParams: this.triage_tool_QueryParams });
  //   }
  // }

  public buildSwiper(index): void {
    this.FormSwiper = new Swiper('.swiper-container', {

      initialSlide: index,
      spaceBetween: 50,
      centeredSlides: true,
      allowTouchMove: false,
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      on: {
        init: function(){
          // console.log('onSwiper:' + this.activeIndex);
          const currSlideHeight = this.slides[this.activeIndex].children[0].clientHeight;
          if (this.activeIndex === 0) {
            this.$el.css({
              height: 100 + '%'
            });
          }

          if (this.activeIndex === 2) {
            this.$el.css({
              height: currSlideHeight + 600 + 'px'
            });
          }else {
            this.$el.css({
              height: currSlideHeight + 43 + 'px'
            });
          }
        },
        slideChange: function () {
          // console.log('slide changed');
        },
        resize: function(){
          const currSlideHeight = this.slides[this.activeIndex].children[0].clientHeight;
          this.$el.css({
            height: currSlideHeight + 43 + 'px'
          });
        }
      }
    });
  }

  NextActiveIndex(event): void {
    // console.log(this.FormSwiper.activeIndex);
    if (this.FormSwiper.activeIndex === 0) {
      this.onClickContinue();
    }else if (this.FormSwiper.activeIndex === 1) {
      this.onSearchSubmit();
    }else if (this.FormSwiper.activeIndex === 2) {
      if (this.symptomDetails !== undefined) {
        this.FormSwiper.slideNext(1000, true);
        this.resetSlideHeight(100);
      }
    }else if (this.FormSwiper.activeIndex === 3) {
      if (this.articleDetails !== undefined) {
        this.FormSwiper.slideNext(1000, true);
        this.resetSlideHeight(100);
      }
    }
  }

  PrevActiveIndex(e): void {
    // console.log(this.FormSwiper.activeIndex);
    if (this.FormSwiper.activeIndex !== 0) {
      this.FormSwiper.slidePrev(1000, true);
      this.resetSlideHeight(100);
    }
  }

  SlideToIndex(index: Number): void {
    this.FormSwiper.slideTo(index, 1);
    this.resetSlideHeight(100);
    if (index === 0) {
      this.SuggestDiagnosisService.onTriggerTrackingEvent('BASIC INFO', null);
    }else if (index === 1) {
      this.SuggestDiagnosisService.onTriggerTrackingEvent('PATIENTS SYMPTOMS', null);
    }else if (index === 2) {
      this.SuggestDiagnosisService.onTriggerTrackingEvent('DIAGNOSIS', null);
    }else if (index === 3) {
      this.SuggestDiagnosisService.onTriggerTrackingEvent('DIAGNOSIS DETAILS', null);
    }else if (index === 4) {
      this.SuggestDiagnosisService.onTriggerTrackingEvent('ARTICLE DETAILS', null);
    }
  }

  public resetSlideHeight (timeout) {
    setTimeout(() => {
      const currSlideHeight = this.FormSwiper.slides[this.FormSwiper.activeIndex].children[0].clientHeight;
      this.FormSwiper.$el.css({
        height: currSlideHeight + 43 + 'px'
      });
    }, timeout);
  }

  public onWindowResize() {
  }
  public onResize() {
    const searchContainer = this.document.querySelector('.overlay-parent');
    this.loadingStyle.width = searchContainer.clientWidth + 'px';
    this.loadingStyle.height = searchContainer.clientHeight + 'px';
  }

  /*--------------------------------------------- Basic Info Start ----------------------------------------------*/
  buildForm(): void {
    this.suggestForm = this.fb.group({
        'ageGroup':  [this.ageGroup, Validators.required],
        'genderCheck': [this.genderCheck, Validators.required],
        'regionGroup':  [this.regionGroup, Validators.required],
        'pregnant':  [this.pregnant, Validators.required],
    });
    this.ageGroupControls = this.suggestForm.get('ageGroup');
    this.genderCheckControls = this.suggestForm.get('genderCheck');
    this.regionGroupControls = this.suggestForm.get('regionGroup');
    this.pregnantControls = this.suggestForm.get('pregnant');
  }

  public ageGroupOnSelect(value): void {
    this.resetSlideHeight(100);
  }
  public resetPregnantValue(value): void {
    if (value === true) {
      setTimeout(() => {
        const currSlideHeight = this.FormSwiper.slides[this.FormSwiper.activeIndex].children[0].clientHeight;
        this.FormSwiper.$el.css({
            height: currSlideHeight + 43 + 'px'
        });
          this.pregnantControls.setValue('0');
        }, 100);
    }else {
      this.resetSlideHeight(100);
      this.pregnantControls.setValue('0');
    }
  }
  markAllFieldsAsTouched(form: FormGroup): void {
      if (form) {
          const allFields: Object = form.controls;
          for (const controlKey of Object.keys(allFields)) {
              if (allFields[controlKey].controls) {
                  this.markAllFieldsAsTouched(allFields[controlKey]);
              } else {
                  allFields[controlKey].markAsTouched();
              }
          }
      }
  }
  public onClickContinue () {
    if (this.suggestForm.valid) {
        this.FormSwiper.slideNext(1000, true);
    }else {
      this.markAllFieldsAsTouched(this.suggestForm);
    }
    this.resetSlideHeight(100);
    this.symptomCheckerId.nativeElement.scrollIntoView();
    this.SuggestDiagnosisService.onTriggerTrackingEvent('PATIENTS SYMPTOMS', null);
  }
  /*---------------------------------------- Symptom Search Enter Edit Operations ----------------------------------------*/
  public onSearchSubmit(): void {
    // console.log(this.suggestForm.value);
    if (this.arraysEqual(this.prevSymptoms, this.symptoms)) {
      this.FormSwiper.slideNext(1000, true);
    }else {
      this.router.navigate(['/suggest-diagnosis/' + this.ageGroupControls.value + '/' + this.genderCheckControls.value + '/' + this.regionGroupControls.value + '/' + this.pregnantControls.value + '/' + this.symptoms.toString()]);
      const origin = window.top.location.origin;
      const hash = window.top.location.hash.split('suggest-diagnosis');
      window.top.history.pushState(null, null, origin + '/web/symptom-checker' + hash[0] + 'suggest-diagnosis/' + this.ageGroupControls.value + '/' + this.genderCheckControls.value + '/' + this.regionGroupControls.value + '/' + this.pregnantControls.value + '/' + this.symptoms.toString());
    }
    this.resetSlideHeight(100);
    this.symptomCheckerId.nativeElement.scrollIntoView();
    this.SuggestDiagnosisService.onTriggerTrackingEvent('DIAGNOSIS', null);
  }
  arraysEqual(a1, a2) {
    /* WARNING: arrays must not contain {objects} or behavior may be undefined */
    return JSON.stringify(a1) === JSON.stringify(a2);
  }

  public onEditBasicDetails(): void {
    this.editBasicHeading = false;
    this.editBasicDetails = false;
  }
  public changeShowStatus(): void {
    this.showSymptomSearch = !this.showSymptomSearch;
    // this.symtomEnterMobile.nativeElement.focus();
  }

  parseWhereNowUrl(url) {
    const whereNowURLTree = this.router.parseUrl(url);
    return {
      age: whereNowURLTree.queryParams.age,
      dx: whereNowURLTree.queryParams.dx,
      pregnancy: whereNowURLTree.queryParams.pregnancy,
      region: whereNowURLTree.queryParams.region,
      sex: whereNowURLTree.queryParams.sex,
      text: whereNowURLTree.queryParams.text
    };
  }


  public getSymptomsAsObservable(token: string): Observable<any> {
    const apiURL =  this.SuggestDiagnosisService.getSymptomSuggestionsAPI() + '&q=' + token;
    return Observable.from(
      this.http.get(apiURL)
      .map((response: Response) => {
          return response.json().suggest.symptomSuggester[token].suggestions;
      })
    );
  }

  public typeaheadOnSelect(e: any): void {
    this.selected = '';
    if (this.symptoms.indexOf(e.item.term) === -1) {
      this.symptoms.push(e.item.term);
    }
  }
  public onEnterSymptom(value: string): void {
    // console.log('onEnterSymptom');
    this.selected = '';
    if (this.symptoms.indexOf(value) === -1 && value !== '') {
      this.symptoms.push(value);
    }
    this.resetSlideHeight(100);
  }

  public onKey(e: any, value: string): void {
    if (e.keyCode === 13) {
      // console.log('onEnterSymptom', value);
      this.selected = '';
      if (this.symptoms.indexOf(value) === -1 && value !== '') {
        this.symptoms.push(value);
      }
     }
  }
  public onRemoveSymptomItem(value: string): void {
    const index = this.symptoms.indexOf(value);
    if (index > -1) {
      this.symptoms.splice(index, 1);
    }
  }
  public onResetSymptomItems(): void {
    this.symptoms = [];
  }

  /** End Symptom Form Enter Edit Operations **/

  /*----------------------------------------------- Start Possible Diagnosis ----------------------------------------------*/
  public showLoadingAndDisplaySearch () {
    const searchContainer = this.document.querySelector('.overlay-parent');
    this.loadingStyle.height = searchContainer.clientHeight + 'px';
    this.loadingStyle.width = searchContainer.clientWidth + 'px';
    this.loadingStyle.display = 'block';
    const searchContanerTop = searchContainer.offsetTop;
    // if (searchContanerTop < $(window).scrollTop()) {
    //   this.loadingSpinnerStyle['margin-top'] = $(window).scrollTop() - searchContanerTop + $(window).height()/2 + "px";
    // } else {
    //   this.loadingSpinnerStyle['margin-top'] = ($(window).height() - (searchContanerTop - $(window).scrollTop()))/2 + "px";
    // }

  }

  onSetResultsheight(filter: any): void {
    this.resetSlideHeight(100);
  }

  /** End Possible Diagnosis **/

  /*---------------------------------------- Start Diagnosis Details & Article Details ----------------------------------------*/

  onClickSymptomDetails(details: any): void {
    this.symptomDetailsShow = true;
    if (details.chunkID !== '0') {
      // console.log(details.chunkID);
      this.articleDetails = undefined;
      this.SymptomDetailsService.getContentSearchDetails(details.chunkID).subscribe(res => {
        this.symptomCheckerId.nativeElement.scrollIntoView();
        this.FormSwiper.slideNext(1000, true);
        this.symptomDetails = this.sanitizer.bypassSecurityTrustHtml(res._body);
        this.resetSlideHeight(100);
      });
    }else {
      this.articleDetails = undefined;
      this.symptomCheckerId.nativeElement.scrollIntoView();
      this.FormSwiper.slideNext(1000, true);
      this.symptomDetails = details.symptomName;
      this.resetSlideHeight(100);
      // console.log(window.location.href);
    }
  }

  onCancelSymptomDetails(): void {
    this.FormSwiper.slideTo(2, 1000);
    this.resetSlideHeight(100);
  }

  onBackToSymptomDetails(): void {
    this.FormSwiper.slideTo(3, 1000);
    this.resetSlideHeight(100);
  }

  onClickArticleDetails(chunkID: String): void {
    this.symptomDetailsShow = true;
    if (chunkID !== undefined && chunkID !== '0') {
      this.SymptomDetailsService.getArticleDetails(chunkID).subscribe(res => {
        this.symptomCheckerId.nativeElement.scrollIntoView();
        this.FormSwiper.slideNext(1000, true);
        this.articleDetails = this.sanitizer.bypassSecurityTrustHtml(res._body);
        this.resetSlideHeight(100);
        // console.log(this.symptomDetails);
      });
    }else {
      console.log(chunkID);
    }
  }
  onClosePopover(event, ElementRef): void {
    const regionPopover = this.document.querySelector('.popover');
    // this.renderer2.listen(this.document, 'click', (event) => {
    //  console.log(regionPopover);
    // });
    // console.log(event.target.innerText);
    if (event.target.innerText !== undefined && event.target.innerText !== '' && event.target.innerText !== 'Selecting your region') {
       ElementRef.close();
    }
    // console.log(ElementRef);
  }
}



// WEBPACK FOOTER //
// ./src/app/suggest-diagnosis/suggest-diagnosis.component.ts